<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        会议预订
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">会议室的预订流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【会议预定】。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第二步：预订页面中蓝色部分为已预约，可点击进入查看预定详情。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第三步：选择预定日期，选择起始时间段、结束时间段后，点击【预约】，进入预约界面。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">会议室的预订流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第四步：将标星处填写完整，确认无误后点击【提交】。视频会议请提前联系资产管理部刘冰（liubing20）调试设备。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第五步：预定会议的撤销。点击预订界面右上角，【我的会议】，进入历史预订界面，进行撤销。</p>
                    <img src="../../assets/17.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
            
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'sd'){
                this.$router.push({name:"IssueManpower2"})
            }else {
                this.$router.push({name:"Administrative"})
            }
        },
        fn() {

        },
        getOnPage() {
            this.$router.push({name: 'Search', params:{code:"1115"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative8.vue